var React = require('react');

function Videos (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5 19V15.0606C5 10.0566 9.02944 6 14 6C18.9706 6 23 10.0566 23 15.0606V19","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 21H9C8.44771 21 8 20.4777 8 19.8333V15.1667C8 14.5223 8.44771 14 9 14H10V21Z","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18 21H19C19.5523 21 20 20.4777 20 19.8333V15.1667C20 14.5223 19.5523 14 19 14H18V21Z","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Videos.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Videos;

Videos.default = Videos;
